export default __webpack_public_path__ + "static/media/StarryNift-hover.2f305fac.png";